/* 10/15 call (Rick + Stef): the site is about getting customers. Lead with the STYLE, show real shop work
   and a price guide, then the artists. Also: "always hiring / guest spots welcome".
   Images are Rick Trip's real work from the Trip Ink vault (fine line = Chris). Stef will send a
   best-example photo + top 3 artists per style; swap them in here when they arrive.
   Portrait card left out: the only portrait photo shows a celebrity likeness. Add it back with a non-celebrity piece. */
const STYLES: [string, string, string, string][] = [
  ['american-traditional', 'American Traditional', 'Bold lines, solid color, built to last.', 'vault-rick-trip_traditional_arm_01.jpg'],
  ['neo-traditional', 'Neo-Traditional', 'Classic bones, richer color and detail.', 'vault-rick-trip_neo-trad_forearm_01.jpg'],
  ['japanese', 'Japanese', 'Koi, dragons, waves. Made for sleeves and backs.', 'vault-rick-trip_japanese_sleeve_01.jpg'],
  ['black-and-grey', 'Black & Grey', 'Smooth shading, soft depth, timeless.', 'vault-rick-trip_black-grey_sleeve_01.jpg'],
  ['color-realism', 'Color Realism', 'Looks like a photo on skin.', 'vault-rick-trip_color-realism_back_01.jpg'],
  ['horror', 'Horror', 'Monsters, movie icons and nightmares.', 'vault-rick-trip_horror_sleeve_01.jpg'],
  ['anime-pop', 'Anime & Pop Culture', 'Characters and fandom, done right.', 'vault-rick-trip_anime-pop_arm_01.jpg'],
  ['fine-line', 'Fine Line & Small', 'Delicate minis and first tattoos.', 'w-71221.jpg'],
];

const PRICES: [string, string][] = [
  ['Full back (about 5 sheets of paper)', 'Quoted by your artist'],
  ['One full sheet of printer paper', '$1,500 – $3,500'],
  ['Half a sheet', '$750 – $1,500'],
  ['Quarter sheet', '$375 – $750'],
  ['Matchbook size', 'About $100'],
];

export const STYLES_HTML = `
<style>
.ti-home .styles{padding:clamp(56px,8vw,140px) clamp(16px,4vw,80px);position:relative}
.ti-home .sgrid{display:grid;grid-template-columns:repeat(auto-fill,minmax(min(100%,260px),1fr));gap:clamp(12px,1.4vw,24px);margin-top:clamp(24px,3vw,48px)}
.ti-home .scard{position:relative;display:block;border-radius:16px;overflow:hidden;aspect-ratio:4/5;background:#111;border:1px solid rgba(255,255,255,.08);text-decoration:none;color:#fff;transition:transform .25s,box-shadow .25s}
.ti-home .scard:hover{transform:translateY(-4px);box-shadow:0 0 0 1px rgba(255,59,63,.6),0 18px 40px rgba(255,40,55,.25)}
.ti-home .scard img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;filter:saturate(1.05)}
.ti-home .scard:after{content:"";position:absolute;inset:0;background:linear-gradient(0deg,rgba(0,0,0,.92) 0%,rgba(0,0,0,.35) 45%,rgba(0,0,0,0) 70%)}
.ti-home .scard .st{position:absolute;left:0;right:0;bottom:0;padding:clamp(14px,1.4vw,24px);z-index:1}
.ti-home .scard h3{font-family:Anton,Impact,sans-serif;font-weight:400;letter-spacing:.04em;font-size:clamp(22px,1.8vw,34px);margin:0 0 .2em;text-transform:uppercase}
.ti-home .scard p{margin:0 0 .7em;font-size:clamp(13px,1vw,17px);color:#ddd;line-height:1.4}
.ti-home .scard .go{display:inline-block;font-size:clamp(12px,.85vw,15px);letter-spacing:.12em;text-transform:uppercase;color:var(--gold2,#ffcf8a)}
.ti-home .pguide{margin-top:clamp(28px,3.5vw,56px);display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,320px),1fr));gap:clamp(16px,2vw,36px);align-items:center;background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);border-radius:18px;padding:clamp(18px,2.4vw,40px)}
.ti-home .pguide h3{font-family:Anton,Impact,sans-serif;font-weight:400;font-size:clamp(26px,2.4vw,44px);margin:.1em 0 .3em;letter-spacing:.03em}
.ti-home .pguide p{color:#cfc9d4;line-height:1.55;margin:0}
.ti-home .ptable{width:100%;border-collapse:collapse;font-size:clamp(14px,1.05vw,19px)}
.ti-home .ptable td{padding:.7em .4em;border-bottom:1px solid rgba(255,255,255,.09)}
.ti-home .ptable td:last-child{text-align:right;color:var(--gold2,#ffcf8a);font-weight:700;white-space:nowrap}
.ti-home .hire{margin-top:clamp(16px,2vw,28px);display:flex;flex-wrap:wrap;gap:12px 20px;align-items:center;justify-content:space-between;border-top:1px dashed rgba(255,255,255,.15);padding-top:clamp(14px,1.6vw,24px)}
.ti-home .hire b{font-family:Anton,Impact,sans-serif;font-weight:400;letter-spacing:.05em;font-size:clamp(20px,1.6vw,30px)}
.ti-home .hire span{color:#cfc9d4}
</style>
<section class="styles" id="styles">
  <div class="head center rv">
    <div class="bulbrow" data-n="9"></div>
    <span class="eyebrow">Start with what you want</span>
    <h2 class="title neon lite">Pick Your Style</h2>
    <p class="sub">Choose the style you love. We match you with the artist at Trip Ink who does it best.</p>
  </div>
  <div class="sgrid">
    ${STYLES.map(([slug, name, blurb, img], i) => `<a class="scard rv" style="--d:${(i % 3) * 0.08}s" href="/book-now?style=${slug}" data-book>
      <img src="assets/${img}" alt="${name} tattoo done at Trip Ink" loading="lazy">
      <div class="st"><h3>${name}</h3><p>${blurb}</p><span class="go">Book this style &rarr;</span></div></a>`).join('')}
  </div>
  <div class="pguide rv">
    <div>
      <span class="eyebrow">What will it cost?</span>
      <h3 class="goldt">Price by Size</h3>
      <p>Hold up a sheet of printer paper. That's your guide. Fold it in half, and the price about halves too. Every piece is different, so your artist confirms the final price.</p>
      <div class="cta" style="margin-top:1em"><a class="btn solid" href="/book-now" data-book>Get Your Quote <span class="arr">&rarr;</span></a><a class="btn" href="tel:702-605-6633">Call Now</a></div>
    </div>
    <table class="ptable" aria-label="Tattoo price guide by size"><tbody>
      ${PRICES.map(([s, p]) => `<tr><td>${s}</td><td>${p}</td></tr>`).join('')}
    </tbody></table>
  </div>
</section>
`;

const HIRE_HTML = `<div class="hire rv"><div><b>Always hiring. Guest spots welcome.</b><br><span>Tattoo artist? Show us your work and tell us about you.</span></div><a class="btn" href="/artist-interview?apply=guest">Apply Here</a></div>`;

/* Applies the style-first changes to the v5 homepage markup. */
export function applyStyleFirst(html: string): string {
  return html
    .replace('<section class="crew" id="crew">', STYLES_HTML + '\n<section class="crew" id="crew">')
    .replace('<a href="#crew">The Crew</a>', '<a href="#styles">Styles</a><a href="#crew">The Crew</a>')
    .replace('Pick your artist, lock your day, and leave with the piece you came for.', 'Pick your style, lock your day, and leave with the piece you came for.')
    .replace(/(<div class="as-cta"><a class="btn solid" href="\/artist-interview">Start Your Interview<\/a><\/div>\s*<\/div>)/, `$1\n  ${HIRE_HTML}`);
}
